import AliPay from './AliPay'

export default AliPay
